import isBoolean = require('lodash/isBoolean');
import {isMobile} from '../../../utils/helpers';
import {ISplitPaneAction} from './actions';
import {TOGGLE_LEFT_BAR, TOGGLE_BOTTOM_BAR} from './constants';

export interface ISplitPaneState {
  leftBarHidden: boolean;
  bottomBarHidden: boolean;
}

export const initialState: ISplitPaneState = {
  leftBarHidden: isMobile(),
  bottomBarHidden: true,
};

const leftBarHidden = (payload, state) => (
  isBoolean(payload.leftBarHidden)
    ? payload.leftBarHidden
    : !state.leftBarHidden
);

const bottomBarHidden = (payload, state) => (
  isBoolean(payload.bottomBarHidden)
    ? payload.bottomBarHidden
    : !state.bottomBarHidden
);

export default (
  state: ISplitPaneState = initialState,
  action: ISplitPaneAction,
): ISplitPaneState => {
  switch (action.type) {
    case TOGGLE_LEFT_BAR:
      return {...state, leftBarHidden: leftBarHidden(action.payload, state)};

    case TOGGLE_BOTTOM_BAR:
      return {...state, bottomBarHidden: bottomBarHidden(action.payload, state)};
    default:
      return state;
  }
};
